customElements.get("video-player") || customElements.define("video-player", class extends HTMLElement {
  constructor() {
    super(), this.video = this.querySelector("video"), this.button = this.querySelector("button"), 
    this.hideOnPlay = this.querySelectorAll("[data-hide]");
  }
  connectedCallback() {
    if (!this.video) return !1;
    this.addEventListeners();
  }
  play() {
    this.video.readyState && (this.pauseAll(), this.video.play());
  }
  pause() {
    this.video.readyState && this.video.pause();
  }
  pauseAll() {
    document.querySelectorAll("video").forEach(e => e.readyState && e.pause());
  }
  onPlay() {
    this.video?.classList.add("is-playing"), this.video.controls = !0, this.hideOnPlay.forEach(e => e.classList.add("hidden")), 
    this.button.classList.add("hidden");
  }
  onPause() {
    this.video?.classList.remove("is-playing"), this.video.controls = !1, this.hideOnPlay.forEach(e => e.classList.remove("hidden")), 
    this.button.classList.remove("hidden");
  }
  addEventListeners() {
    this.button?.addEventListener("click", () => this.play()), [ "play", "playing" ].forEach(e => this.video.addEventListener(e, this.onPlay.bind(this))), 
    [ "pause", "ended" ].forEach(e => this.video.addEventListener(e, this.onPause.bind(this)));
  }
});